import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, take, tap } from "rxjs/operators";
import { selectCurrentSite, selectIsLoggedIn } from "./auth.selectors";
import { MatDialog } from "@angular/material/dialog";
import { AppState } from "../../app.reducer";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.store.pipe(
      select(selectIsLoggedIn),
      take(1),
      map((isLoggedIn) => {
        if (!isLoggedIn) {
          // Save the attempted URL for redirecting after login
          const returnUrl = state.url;
          return this.router.createUrlTree(['/login'], {
            queryParams: { returnUrl }
          });
        }
        return true;
      }),
    );
  }
}
